import React from "react";
import Paginator from "./paginator.jsx";
import { Checkbox } from "react-bootstrap";
import TimecardListItem from "./timecard-list-item2.jsx";

export default class TimecardList2 extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.vm.timecards !== nextProps.vm.timecards;
    }

    render() {
        console.log("LIST");
        let items = []

        let vm = this.props.vm; // Expected to be an array of listItem       
        if (vm == null || vm.timecards == null || vm.timecards == 0) {
            return (
                <div className="ap-fullsize ap-grid-result text-center">
                    No Timecard Found!
                </div>
            );
        } else {
            for (let i = 0; i < vm.timecards.length; i++) {
                let dataItem = vm.timecards[i];
                items.push(
                    <TimecardListItem vm={dataItem} key={`${dataItem.timecardSummary.timecardId}_${i}`} role={this.props.role}
                        onChecked={this.props.onTcItemChecked} onStaffChange={this.props.onStaffChange}
                        onSearch={this.props.onSearch}
                        toggleSubmitTimecardDialog={this.props.toggleSubmitTimecardDialog}
                        showSubmitTimecardDialog={this.props.showSubmitTimecardDialog} />
                );
            }

            return (
                <div className="ap-timecard-list-container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="container-fluid ap-timecard-list-header">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-1 col-lg-1">
                                        <Checkbox className="ap-header-checkbox ap-no-margin-left" checked={vm.isAllSelected === true}
                                            onChange={() => this.props.onTcItemChecked("all")} />
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard">
                                        <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("T.PEOPLE_NAME", this.props.onSearch); return false; }} >Name</a></span>
                                        {this.props.sortExpression == 'T.PEOPLE_NAME' ? <span className="glyphicon glyphicon-arrow-down" /> : null}
                                        {this.props.sortExpression == 'T.PEOPLE_NAME DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : null}
                                    </div>
                                    {
                                        this.props.role.toLowerCase() == 'supervisor' ?
                                            <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title">
                                            </div> :
                                            null
                                    }
                                    {
                                        this.props.role.toLowerCase() == 'payroll-admin' ?
                                            <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard">
                                                <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("T.REPORT_TO_NAME", this.props.onSearch); return false; }} >Report To</a></span>
                                                {this.props.sortExpression == 'T.REPORT_TO_NAME' ? <span className="glyphicon glyphicon-arrow-down" /> : null}
                                                {this.props.sortExpression == 'T.REPORT_TO_NAME DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : null}
                                            </div> :
                                            null
                                    }
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title verify-timecard ap-no-padding-right">
                                        <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("STATUS", this.props.onSearch); return false; }} >Status</a></span>
                                        {this.props.sortExpression == 'STATUS' ? <span className="glyphicon glyphicon-arrow-down" /> : null}
                                        {this.props.sortExpression == 'STATUS DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : null}
                                    </div>
                                    <div className="hidden-xs hidden-sm col-md-1 col-lg-1 ap-col-title verify-timecard ap-no-padding-right">
                                        <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("T.PLACEMENT_ID", this.props.onSearch); return false; }} >{this.props.role.toLowerCase() == 'supervisor' ? 'ID' : 'Assign ID'}</a></span>
                                        {this.props.sortExpression == 'T.PLACEMENT_ID' ? <span className="glyphicon glyphicon-arrow-down" /> : ''}
                                        {this.props.sortExpression == 'T.PLACEMENT_ID DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : ''}
                                    </div>
                                    <div className={"hidden-xs hidden-sm " + (this.props.role.toLowerCase() == 'supervisor' ? "col-md-6 col-lg-6" : "col-md-5 col-lg-5") + " ap-col-title"}>
                                        <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard">
                                            <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("TL.REGULAR_TOTAL", this.props.onSearch); return false; }} >Reg</a></span>
                                            {this.props.sortExpression == 'TL.REGULAR_TOTAL' ? <span className="glyphicon glyphicon-arrow-down" /> : ''}
                                            {this.props.sortExpression == 'TL.REGULAR_TOTAL DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : ''}
                                        </div>
                                        <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard">
                                            <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("TL.OT_TOTAL", this.props.onSearch); return false; }} >OT</a></span>
                                            {this.props.sortExpression == 'TL.OT_TOTAL' ? <span className="glyphicon glyphicon-arrow-down" /> : ''}
                                            {this.props.sortExpression == 'TL.OT_TOTAL DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : ''}
                                        </div>
                                        <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard">
                                            <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("TL.DT_TOTAL", this.props.onSearch); return false; }} >DT</a></span>
                                            {this.props.sortExpression == 'TL.DT_TOTAL' ? <span className="glyphicon glyphicon-arrow-down" /> : ''}
                                            {this.props.sortExpression == 'TL.DT_TOTAL DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : ''}
                                        </div>
                                        <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard ap-no-padding-right">
                                            <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("E.MISC_TOTAL", this.props.onSearch); return false; }} >Misc</a></span>
                                            {this.props.sortExpression == 'E.MISC_TOTAL' ? <span className="glyphicon glyphicon-arrow-down" /> : ''}
                                            {this.props.sortExpression == 'E.MISC_TOTAL DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : ''}
                                        </div>
                                        <div className="hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard ap-no-padding-right">
                                            <span><a href="#" onClick={(evt) => { evt.preventDefault(); this.props.onSortChange("TL.TOTAL_TOTAL", this.props.onSearch); return false; }} >Total</a></span>
                                            {this.props.sortExpression == 'TL.TOTAL_TOTAL' ? <span className="glyphicon glyphicon-arrow-down" /> : ''}
                                            {this.props.sortExpression == 'TL.TOTAL_TOTAL DESC' ? <span className="glyphicon glyphicon-arrow-up" /> : ''}
                                        </div>
                                        <div className={"hidden-xs hidden-sm col-md-2 col-lg-2 ap-col-title verify-timecard"}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="container-fluid ap-timecard-list">
                                {items}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Paginator total={this.props.totalPage} range="3" selectedIndex={this.props.page}
                                onNavigate={this.props.onNavigate} />
                        </div>
                    </div>
                </div>
            );
        }
    }
}